const buttonStyleDecorator = (buttonStyle, style, theme, isLoading) => {
  switch (buttonStyle) {
    case 'secondary':
      {
        return {
          ...style,
          color: theme.tokens.ComponentBtnSecondaryColor,
          backgroundColor: theme.tokens.ComponentBtnSecondaryBg,
          borderColor: !isLoading ? theme.tokens.ComponentBtnSecondaryBorder : theme.tokens.SemColorBorderButtonDividerDisabled,
          transition: 'all 0.25s ease-in-out',
          '&.Mui-focusVisible': {
            color: theme.tokens.ComponentBtnSecondaryFocusColor,
            backgroundColor: theme.tokens.ComponentBtnSecondaryFocusBg,
            borderColor: theme.tokens.ComponentBtnSecondaryFocusBorder,
            boxShadow: theme.tokens.ComponentBtnSecondaryFocusBoxShadow
          },
          '&:hover': {
            color: theme.tokens.ComponentBtnSecondaryHoverColor,
            backgroundColor: theme.tokens.ComponentBtnSecondaryHoverBg,
            borderColor: theme.tokens.ComponentBtnSecondaryHoverBorder
          },
          '&.active,&:active': {
            color: theme.tokens.ComponentBtnSecondaryActiveColor,
            backgroundColor: theme.tokens.ComponentBtnSecondaryActiveBg,
            borderColor: theme.tokens.ComponentBtnSecondaryActiveBorder,
            backgroundImage: 'none'
          }
        };
      }
    case 'aux':
      {
        return {
          ...style,
          color: theme.tokens.ComponentBtnAuxColor,
          backgroundColor: theme.tokens.ComponentBtnAuxBg,
          borderColor: theme.tokens.ComponentBtnAuxBorder,
          transition: 'all 0.25s ease-in-out',
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
          fontStyle: 'normal',
          fontStretch: '32%',
          fontWeight: '400',
          fontVariationSettings: "'GRAD' 0, 'slnt' 0, 'XTRA' 468, 'YOPQ' 79, 'YTLC' 514, 'YTUC' 712, 'YTAS' 750, 'YTDE' -203, 'YTFI' 738;",
          '&.Mui-focusVisible': {
            color: theme.tokens.ComponentBtnAuxFocusColor,
            backgroundColor: theme.tokens.ComponentBtnAuxFocusBg,
            borderColor: theme.tokens.ComponentBtnAuxFocusBorder,
            boxShadow: theme.tokens.ComponentBtnAuxFocusBoxShadow
          },
          '&:hover': {
            color: theme.tokens.ComponentBtnAuxHoverColor,
            backgroundColor: theme.tokens.ComponentBtnAuxHoverBg,
            borderColor: theme.tokens.ComponentBtnAuxHoverBorder
          },
          '&.active,&:active': {
            color: theme.tokens.ComponentBtnAuxActiveColor,
            backgroundColor: theme.tokens.ComponentBtnAuxActiveBg,
            borderColor: theme.tokens.ComponentBtnAuxActiveBorder,
            backgroundImage: 'none'
          },
          '& .MuiButton-startIcon': {
            marginLeft: '0',
            marginRight: '0'
          },
          '& .MuiButton-endIcon': {
            marginLeft: '0',
            marginRight: '0'
          },
          '&.MuiButtonBase-root': {
            gap: '4px'
          }
        };
      }
    case 'tertiary':
      {
        return {
          ...style,
          color: theme.tokens.ComponentBtnTextColor,
          backgroundColor: theme.tokens.ComponentBtnTextBg,
          border: '0',
          transition: 'all 0.25s ease-in-out',
          '&.Mui-focusVisible': {
            color: theme.tokens.ComponentBtnTextFocusColor,
            backgroundColor: theme.tokens.ComponentBtnTextFocusBg,
            borderColor: theme.tokens.ComponentBtnTextFocusBorder,
            boxShadow: theme.tokens.ComponentBtnTextFocusBoxShadow
          },
          '&:hover': {
            color: theme.tokens.ComponentBtnTextHoverColor,
            backgroundColor: theme.tokens.ComponentBtnTextHoverBg,
            borderColor: theme.tokens.ComponentBtnTextHoverBorder
          },
          '&.active,&:active': {
            color: theme.tokens.ComponentBtnTextActiveColor,
            backgroundColor: theme.tokens.ComponentBtnTextHoverBg,
            borderColor: theme.tokens.ComponentBtnTextActiveBorder,
            backgroundImage: 'none'
          }
        };
      }
    case 'primary':
    default:
      {
        return {
          ...style,
          color: theme.tokens.ComponentBtnPrimaryColor,
          backgroundColor: theme.tokens.ComponentBtnPrimaryBg,
          border: '0',
          transition: 'all 0.25s ease-in-out',
          '&.Mui-focusVisible': {
            color: theme.tokens.ComponentBtnPrimaryFocusColor,
            backgroundColor: theme.tokens.ComponentBtnPrimaryFocusBg,
            boxShadow: theme.tokens.ComponentBtnPrimaryFocusBoxShadow
          },
          '&:hover, &.hover': {
            color: theme.tokens.ComponentBtnPrimaryHoverColor,
            backgroundColor: theme.tokens.ComponentBtnPrimaryHoverBg
          },
          '&.active, &:active': {
            color: theme.tokens.ComponentBtnPrimaryActiveColor,
            backgroundColor: theme.tokens.ComponentBtnPrimaryActiveBg
          }
        };
      }
  }
};
export default buttonStyleDecorator;